module.exports = __webpack_public_path__ + "static/media/Политика относно упражняване на правата на субектите на данни.a9f3b39f.pdf";